
<template>
    <div class="footer-copyright">
        <p>{{author.text}}  {{author.version}}</p>
    </div>
</template>
<script>
export default {
    //validate data
    props:{
        author:{
            type:Object,
            required:true
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/SystemAuthor.vue